import { withInstall } from '@zoryn/utils'
import PageHeader from './src/page-header.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZPageHeader: SFCWithInstall<typeof PageHeader> =
  withInstall(PageHeader)
export default ZPageHeader

export * from './src/page-header'
